"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../utils");
var _excluded = ["isLoading", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 *
 * A wrapper component that visually indicates whether a child component
 * is loading, or loaded.
 *
 * LoadingContainer renders child components with modified opacity
 * depending on whether `isLoading` is true or false
 *
 *
 * @name LoadingContainer
 * @type Function
 * @param {Boolean} [isLoading=false] Whether the inner component should be indicated as loading
 * @example
 *
 * function PatientIndex ({ patientProfiles }) {
 *   return (
 *      <div>
 *         <LoadingContainer isLoading={ !patientProfiles }>
 *           <div> Child Component </div>
 *         </LoadingContainer>
 *      </div>
 *   )
 * }
 *
 */

var propTypes = {
  isLoading: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].node
};
var defaultProps = {
  isLoading: false
};
function LoadingContainer(_ref) {
  var isLoading = _ref.isLoading,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _classnames["default"])({
      'is-loading': isLoading
    })
  }, (0, _utils.filterInvalidDOMProps)(rest)), children);
}
LoadingContainer.propTypes = propTypes;
LoadingContainer.defaultProps = defaultProps;
var _default = LoadingContainer;
exports["default"] = _default;